module.exports = __webpack_public_path__ + "img/motobike-crash.35689743.svg";